import { useState } from 'react'
import { Cities } from './Cities'
import { Countries } from './Countries'
import { RallyCities } from './RallyCities'
import { AddDemoForm } from './AddDemoForm'
import type { Rally } from '../../data/rallies'
import { useTranslation } from 'react-i18next'

function Events({ rally }: { rally?: Rally }) {
  const { t } = useTranslation()
  const [view, setView] = useState<'cities' | 'countries'>(() => {
    if (typeof window !== 'undefined' && window.innerWidth < 768) {
      return 'countries'
    }
    return 'cities'
  })

  return (
    <section
      id='rally-schedule'
      aria-labelledby='event-schedule-heading'
      className='w-full px-6 md:px-20 pb-25 pt-10 justify-center bg-gray-100 text-center text-blue-700'
    >
      <div className='flex justify-center my-6 px-8'>
        {view === 'cities' && (
          <button
            onClick={() => setView('countries')}
            className='
                rounded-full
                bg-blue-800 text-white
                px-6 py-3
                shadow-lg
                hover:bg-blue-700
                cursor-pointer
                transition'
          >
            {t('byCountry')}
          </button>
        )}
        {view === 'countries' && (
          <button
            onClick={() => setView('cities')}
            className='
                rounded-full
                bg-blue-800 text-white
                px-6 py-3
                shadow-lg
                hover:bg-blue-700
                cursor-pointer
                transition'
          >
            {t('byDate')}
          </button>
        )}
      </div>

      {view === 'cities' && (rally ? <RallyCities rally={rally} /> : <Cities />)}
      {view === 'countries' && <Countries rally={rally} />}

      {rally && <AddDemoForm />}
    </section>
  )
}

export default Events
